import React from 'react';
import { useSelector } from 'react-redux';
import { Route, RouteProps, Redirect } from 'react-router';

import { selectIsLoginPending, selectIsLoginResolved } from '@/store/selectors/auth';
import { selectRole } from '@/store/selectors/user';

import Loader from '@/components/common/Loader';

/**
 * ProtectedRouterAdmin admits everyone who is not a developer, which means hr
 * and sales reach it too. Salary must not be one of those screens, so this one
 * checks for the admin role itself.
 *
 * The back end is the authority either way -- every salary route sits behind
 * protectAdminRoute -- this only keeps the link from opening a screen that would
 * come back empty.
 */
const ProtectedRouterStrictAdmin: React.FC<RouteProps> = (props) => {
  const isLoading = useSelector(selectIsLoginPending);
  const isLoggedIn = useSelector(selectIsLoginResolved);
  const role = useSelector(selectRole);
  const { path } = props;

  if (isLoading) return <Loader />;

  if (!isLoggedIn) return <Redirect to={`/login${path}`} />;

  return role === 'admin' ? <Route {...props} /> : <Redirect to="/me" />;
};

export default ProtectedRouterStrictAdmin;
